import { spacing } from '@upstox/upstox-ui';

export const wrapper: CSSFunction = ({ theme }) => ({
  padding: spacing(theme, ['xlarge']),
});
